import React, { useEffect } from 'react';

import {
  Flex, Stack, Text, useToast,
} from '@chakra-ui/react';
import { FormProvider, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';

import { recovery } from 'api/auth';
import { Input, Button } from 'components';
import requestPasswordRecovery from 'validations/requestPasswordRecovery';

export default function Recovery() {
  const { push, location } = useHistory();
  const toast = useToast();
  const form = useForm({
    mode: 'all',
    resolver: requestPasswordRecovery,
  });

  useEffect(() => {
    if (location.search.includes('next')) {
      toast({
        title: 'Acesso negado!',
        description: 'Você precisa estar logado para acessar a plataforma!',
        status: 'info',
        duration: 5000,
        position: 'top-right',
        isClosable: true,
      });
    }
  }, []);

  const {
    register, handleSubmit, setError, formState: { dirtyFields },
  } = form;
  const { mutate, isLoading } = useMutation(recovery, {
    onSuccess: () => {
      push('signup');
    },
    onError: (error: any) => {
      if (error.errors) {
        error.errors.forEach((err) => {
          if (err.field) {
            setError(err.field, err);
          } else {
            setError(Object.keys(dirtyFields)[0], err);
          }
        });
      } else {
        toast({
          title: 'Ocorreu um erro.',
          description: error.message,
          status: 'error',
          duration: 5000,
          position: 'top-right',
          isClosable: true,
        });
      }
    },
  });

  const onSubmit = (data) => mutate({ data });

  return (
    <Stack
      width="100%"
      alignItems="center">
      <Text
        variant="2xLargeSemiBold"
        color="secondary.default">
        Recuperação de Conta
      </Text>
      <Text
        color="gray.500"
        textAlign="center"
        variant="mediumRegular">
        Um novo código de acesso será enviado para o seu email.
      </Text>
      <FormProvider {...form}>
        <Flex
          onSubmit={handleSubmit(onSubmit)}
          pt={6}
          width="100%"
          flexDir="column"
          as="form"
          justifyContent="space-between"
          flex={1}>
          <Input
            placeholder="nome@email.com"
            viewProps={{
              mb: 6,
            }}
            label="Email"
            {...register('email')}
          />
          <Button
            isLoading={isLoading}
            type="submit"
            size="xs"
            variant="primary.blue">
            <Text variant="smallBold">
              Entrar
            </Text>
          </Button>
        </Flex>
      </FormProvider>
    </Stack>
  );
}
